/*
 * PHONES
 */
export const phoneMaskEurope = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]

export const postcodeMaskJapan = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]

export const phoneMaskJapanPart1 = [0, /\d/, /\d/, /\d/, /\d/]

export const phoneMaskJapanPart2 = [/\d/, /\d/, /\d/, /\d/]

export const phoneMaskJapanPart3 = [/\d/, /\d/, /\d/, /\d/]

export const phoneMaskRussian = [
  '+',
  '7',
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
]

// export const dateDependedOnLang = lang => {
//   switch (lang) {
//     case 'ru':
//       return dateDDMMYYYY
//     default:
//       return dateDDMMYYYY
//   }
// }
